import JustValidate from 'just-validate';
export class CollegeCosts {

	constructor() {
	}
	init() {
		const calculators = document.querySelectorAll('.calculator-section.type-college_costs');
		if (!calculators) {
			return;
		}

		calculators.forEach(calculator => {
			let initial = true;
			const form = calculator.querySelector('form');
			const select = calculator.querySelector('select[name=year]')
			const validator = new JustValidate(form, {
				validateBeforeSubmitting: false,
			});
			validator.addField('#year', [
				{
					rule: 'required',
					errorMessage: 'Please choose a starting year'
				},
			]);
			validator.onSuccess((e) => {
				const year = calculator.querySelector('select[name=year]').value;
				var calcDate = new Date();

				var pctInflateVal = this.mefaMultiplier(window.MEFA_DATA_COST?.pctval);
				console.log(pctInflateVal);

				var yearDiff = parseInt(year) - calcDate.getFullYear();
				yearDiff = yearDiff < 0 ? 0 : yearDiff;

				// loop my year rows
				for (let yearInc = 0; yearInc < 4; yearInc++) {
					this.estimatorCalcLoad(calculator, 'tr.chart-year-' + yearInc, (yearInc + yearDiff), pctInflateVal, window.MEFA_DATA_COST,(parseInt(year)+yearInc));
				}

				calculator.querySelector('.results').classList.remove('visually-hidden');
				window.mefaBuildMobileCalcResults(calculator, "Tuition By Year");
				if(!initial){
					const resultRect = calculator.querySelector('.results').getBoundingClientRect();
					if (resultRect.top < window.innerHeight && resultRect.bottom > 0) {
						return;
					}
					window.scrollTo({
						top: resultRect.top + window.pageYOffset - 100,
						behavior: 'smooth'
					});
				}
				initial = false;
			})
			validator.onFail((e) => {
				console.log("fail");
			});

			select.addEventListener('change', (e) => {
				e.preventDefault();
				validator.revalidate();
			});
			validator.revalidate();

			const buildMobile = function(dropTitle){

			}

		});
	}
	estimatorCalcLoad(calculator, chartYear, yearDiff, infVal, estLocal, year) {
		const yearEl = calculator.querySelector(`${chartYear} .chart-left`);
		const pub2y = calculator.querySelector(`${chartYear} td.npub2y`);
		const pub4yis = calculator.querySelector(`${chartYear} td.npub4yis`);
		const pub4yos = calculator.querySelector(`${chartYear} td.npub4yos`);
		const piv4y = calculator.querySelector(`${chartYear} td.npiv4y`);
		yearEl.textContent = year;
		pub2y.textContent = this.mefaCostYear(estLocal.npub2y, yearDiff, infVal);
		pub4yis.textContent = this.mefaCostYear(estLocal.npub4yis, yearDiff, infVal);
		pub4yos.textContent = this.mefaCostYear(estLocal.npub4yos, yearDiff, infVal);
		piv4y.textContent = this.mefaCostYear(estLocal.npiv4y, yearDiff, infVal);
	}


	mefaCostYear(tVal, tInc, tPct) {
		// if we have no incrementer, just return
		if (tInc === 0) {
			return this.mefaCommaNum(parseFloat(tVal).toFixed(2));
		}
		// set an initial value for the first increment
		let tCalc = parseFloat(tVal) * parseFloat(tPct);
		// if we only have 1, return that
		if (tInc < 2) {
			return this.mefaCommaNum(parseFloat(tCalc).toFixed(2));
		}
		// set a variable for our counting
		var count;
		// we have more than one. go forth
		for (count = 1; count < (tInc); count++) {
			tCalc = parseFloat(tCalc) * parseFloat(tPct);
		}
		// now return it (it should be the last number in the cycle)
		return this.mefaCommaNum(parseFloat(tCalc).toFixed(2));
	}
	mefaMultiplier(nVal) {
		// set my base value
		let nBase = 1;
		// check for 1 or below
		if (nVal < 2) {
			return Number(nBase);
		}
		// check for vals over 99
		if (nVal > 99) {
			return Number(nBase + 1);
		}
		// now our numbers within range
		return Number(nBase + (nVal / 100));
	}
	mefaCommaNum(nStr){
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		return '$' + x1 + x2
	}
	addReadableComma(num) {
		var parts = num.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
}
